import { createSelector } from 'reselect'

const getUserImage = state => state.user.data.image
const qsSelector = state => state.qs

const getNavigationMenuData = createSelector(
	[getUserImage, qsSelector],
	(userImage, qs) => ({
		userImage,
		view: qs.navigationMenuView,
	})
)

export default getNavigationMenuData
